import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {PurchaseGiftMapper} from '../mappers/purchase-gift.mapper';

@Injectable({
    providedIn: 'root'
})
export class PurchaseGiftCardUseCase {
    constructor(
        private mapper: PurchaseGiftMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run(data) {
      return this.data.purchaseGift(data).pipe(this.mapper.map);
    }
}
